module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAABVCAYAAAA8AHhnAAAACXBIWXMAABYlAAAWJQFJUiTwAAABE0lEQVR4nO3cQW0DQRBFwXZkAIZiCLksLofXHGwIgRAIhhAFRHki6xWBr36Huay0p7XW10T4Oc/MrbTE4+MNj/o3igsVFyouVFyouFBxoeJCxYWKCxUXKi5UXKi4UHGh4kLFhYoLFRf6+4b22LR9mZnrC3Z23fd92jQ8a63PmbnrneM4tt3YswAVFyouVFyouFBxoeJCxYWKCxUXKi5UXKi4UHGh4kLFhYoLFRcqLlRcqLhQcaHiQsWFigsVFyouVFyouFBxoeJCxYWKCxUXKi5UXKi4UHGh4kLFhYoLFRcqLlRcqLhQcaHiQsWFigsVFyouVFyouFBxoeJCxYWKCxUXKi5UXKi40Hnj9nPj71e9mfkFmpINv1YVaUIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/38.png
// module id = duew
// module chunks = 1